import { InvoiceAmount } from './invoice-amount.model';

export class InvoicePrice {
  invoiceAmount: InvoiceAmount;
  quantity: number;
  vatCode: number;

  constructor(values= {}) {
    Object.assign(this, values);
    this.invoiceAmount = this.invoiceAmount ? new InvoiceAmount(this.invoiceAmount) : new InvoiceAmount();
  }
}
